// extracted by mini-css-extract-plugin
module.exports = {"container":"ClipText_container__9CJUo","inner":"ClipText_inner__gAvtL"};